
import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import CertificationReview from './CertificationReview';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { FileText, Loader2 } from 'lucide-react';

const AdminCertificationsList: React.FC = () => {
  const { data: pendingCertifications, isLoading, refetch } = useQuery({
    queryKey: ['admin-pending-certifications'],
    queryFn: async () => {
      console.log('Fetching pending certifications for admin review...');
      
      const { data, error } = await supabase
        .from('practitioner_certifications')
        .select(`
          *,
          practitioners(
            id,
            first_name,
            last_name
          )
        `)
        .eq('status', 'pending_review')
        .order('created_at', { ascending: false });

      if (error) {
        console.error('Error fetching pending certifications:', error);
        throw error;
      }

      console.log('Fetched pending certifications:', data);
      return data;
    },
  });

  if (isLoading) {
    return (
      <div className="flex justify-center py-8">
        <Loader2 className="h-8 w-8 animate-spin text-amber-600" />
      </div>
    );
  }

  if (!pendingCertifications || pendingCertifications.length === 0) {
    return (
      <div className="text-center py-8">
        <FileText className="h-12 w-12 text-gray-400 mx-auto mb-4" />
        <h3 className="text-lg font-medium text-gray-900 mb-2">No pending certifications</h3>
        <p className="text-gray-500">All certifications have been reviewed.</p>
      </div>
    );
  }

  return (
    <div className="grid gap-4">
      {pendingCertifications.map((cert) => (
        <Card key={cert.id} className="border rounded-lg">
          <CardHeader className="pb-2">
            <CardTitle className="text-base font-medium">
              {cert.practitioners?.first_name || 'Unknown'} {cert.practitioners?.last_name || 'Practitioner'}
            </CardTitle>
            <p className="text-sm text-gray-600">
              Practitioner ID: {cert.practitioner_id.slice(0, 8)}...
            </p>
          </CardHeader>
          <CardContent>
            <CertificationReview
              certification={cert}
              onStatusUpdate={refetch}
            />
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default AdminCertificationsList;
